import { render, staticRenderFns } from "./DmsReferenceForm.vue?vue&type=template&id=ca9dc66a&"
import script from "./DmsReferenceForm.vue?vue&type=script&lang=js&"
export * from "./DmsReferenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports